import { h } from "@stencil/core";

export const ChevronRight = () => (
    <svg viewBox='0 0 48 48' role='img' fill='currentColor'>
        <path d='M24,8l-4,0l9.6,16L20,40l4,0l9.6-16L24,8z'></path>
    </svg>
);
